// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCursor_container__EeBvB","cursor":"CustomCursor_cursor__8V1Cu"};